export const jobStaus = {
  1: "Scheduled",
  2: "Started wrapping",
  3: "Wrapping finished",
  "-1": "Expired",
};
